// extracted by mini-css-extract-plugin
export default {"dialog":"dialog__sAq0g","dialog-content":"dialog-content__2MHsh","editor-box":"editor-box__A-hYa"};